import { STAFF_LOGIN, IS_LOADING, IS_LOADED, SHOW_ERROR, CLEAR_ERROR, REMOVE_TOKEN, SAVE_STAFF_REDIRECT_URL, SAVE_STAFF_USER_TYPE } from '../actions/type';

const initState = {
    staff: null,
    isAuthenticated : false,
    isLoading: false,
    error: null,
    token: localStorage.getItem("laundry-staff"),
    redirectUrl: localStorage.getItem("laundry-staff-redirect-url"),
	userType: localStorage.getItem("laundry-staff-user-type"),
};

const staffReducer = (state = initState, action) => {
    switch(action.type) {
        case IS_LOADING:
            return {
                ...state,
                isLoading: true
            };
        case IS_LOADED:
            return {
                ...state,
                isLoading: false
            };
        case SHOW_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: null
            };
        case STAFF_LOGIN:
            localStorage.setItem("laundry-staff", action.payload.token);
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.token,
                staff: action.payload.staff
            };
        case SAVE_STAFF_REDIRECT_URL:
            localStorage.setItem("laundry-staff-redirect-url", action.payload);
            return {
                ...state,
                redirectUrl: action.payload
            };
		case SAVE_STAFF_USER_TYPE:
			localStorage.setItem("laundry-staff-user-type", action.payload);
			return {
				...state,
				userType: action.payload
			};
        case REMOVE_TOKEN:
			localStorage.removeItem("laundry-staff");
			localStorage.removeItem("laundry-staff-redirect-url");
			localStorage.removeItem("laundry-staff-user-type");
			return {
				...state,
				isAuthenticated: false,
                token: null,
                staff: null,
                redirectUrl: null,
                userType: null,
			};
        default:
            return state;
    }
};

export default staffReducer;